import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-96" data-mp="2af6saadxxlh">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-2 focus:text-white" data-id="element-97" data-mp="gyjobaxpc32o">
        Aller au contenu principal
      </a>
      <Header data-id="element-98" data-mp="3kmld3bx552s0" />
      <main id="contenu" className="flex-1" data-id="element-99" data-mp="3kmbvabm921xe">
        <Outlet data-id="element-100" data-mp="3foju0qzpt3gj" />
      </main>
      <Footer data-id="element-101" data-mp="3fpbr668yn98x" />
    </div>;
}